// Resolves a catalog role's localized display name from its `names` map
// (CatalogRoleResponse.names, carried through by accessTransformer) — the
// same fallback shape as domains' domainDisplayName
// (features/roles/transform/domainDisplayName.ts). Only yaml presets carry
// translations; a tenant-custom or migrated-bridge role's `names` map is
// always empty, so it falls straight through to whatever label the caller
// already shows for it (its description, or the raw id when there is none).
import type { CatalogRole } from '../types'

export function roleDisplayName(role: CatalogRole, language: string): string {
  return role.names[language] ?? role.names.en ?? (role.description || role.id)
}
